import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { SearchIcon } from 'components/lib/icons'
import { colors } from 'config/ui'
import Input, { inputPropTypes } from './Input'

class Search extends Component {
  static propTypes = {
    ...inputPropTypes,
    onSubmit: PropTypes.func,
    customKeyUpEvt: PropTypes.func,
    searchIconStyle: PropTypes.object
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.location !== this.props.location &&
      this.input &&
      this.input.value.length
    ) {
      this.input.value = ''
    }
  }

  handleKeyUp = key => {
    const { onSubmit, customKeyUpEvt } = this.props

    if (key === 'Enter' && onSubmit) {
      return onSubmit(this.input)
    }

    customKeyUpEvt && customKeyUpEvt(this.input)
  }

  handleClickSearchIcon = () => {
    const { onSubmit } = this.props

    if (this.input.value.length && onSubmit) {
      onSubmit(this.input)
    }

    this.input.focus()
  }

  render() {
    const { secondary, ...rest } = this.props
    const searchIconStyle = {
      margin: '10px',
      width: '20px',
      height: '20px',
      minWidth: '18px',
      minHeight: '18px',
      cursor: 'pointer'
    }

    return (
      <Input
        onKeyUp={this.handleKeyUp}
        type="search"
        inputRef={ref => {
          this.input = ref
          this.props.searchInputRef && this.props.searchInputRef(ref)
        }}
        secondary={secondary}
        {...rest}
      >
        <SearchIcon
          onClick={this.handleClickSearchIcon}
          style={
            secondary
              ? {
                  searchIconStyle,
                  ...{
                    margin: '8px 12px',
                    width: '18px',
                    height: '18px',
                    minWidth: '16px',
                    minHeight: '16px',
                    cursor: 'pointer'
                  }
                }
              : searchIconStyle
          }
          color={secondary ? colors.gray7 : colors.darkGray}
        />
      </Input>
    )
  }
}

export default withRouter(Search)
